import { memo } from "react"

const IconArrowUpGreen = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3 8 H11 L8 11 M11 8 L8 5"
        stroke="#969696"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconArrowUpGreen)
